/* unplugin-vue-components disabled */import { render } from "./Hierarchy.vue?vue&type=template&id=1ffd0ef8&scoped=true"
import script from "./Hierarchy.vue?vue&type=script&lang=js"
export * from "./Hierarchy.vue?vue&type=script&lang=js"

import "./Hierarchy.vue?vue&type=style&index=0&id=1ffd0ef8&scoped=true&lang=css"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffd0ef8"]])

export default __exports__